import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { primaryNavigation, serviceNavigation } from '../../data/navigation';

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <div className="mobile-menu">
      <button
        className={`mobile-menu-toggle${isOpen ? ' is-open' : ''}`}
        type="button"
        aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isOpen}
        aria-controls="mobile-navigation"
        onClick={() => setIsOpen((current) => !current)}
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </button>

      <div id="mobile-navigation" className={`mobile-menu__panel${isOpen ? ' is-open' : ''}`}>
        <nav className="mobile-menu__nav" aria-label="Mobile navigation">
          {primaryNavigation.map((item) =>
            item.path === '/services' ? (
              <div key={item.path} className="mobile-menu__group">
                <NavLink to={item.path}>{item.label}</NavLink>
                <div className="mobile-menu__subnav" aria-label="Mobile services navigation">
                  {serviceNavigation.map((service) => (
                    <NavLink key={service.path} to={service.path}>
                      {service.label}
                    </NavLink>
                  ))}
                </div>
              </div>
            ) : (
              <NavLink key={item.path} to={item.path}>
                {item.label}
              </NavLink>
            )
          )}
          <NavLink to="/contact" className="mobile-menu__quote">
            Request a Quote
          </NavLink>
        </nav>
      </div>
    </div>
  );
}

export default MobileMenu;
